//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url +  Vue.prototype.$config.interview.base

const interview = {
  create(payload:any) {
    return Vue.prototype.$httpService
    .post(url, payload)
  },
  edit(id:string|number,payload:any) {
    let Url = url.replace("{0}", id) 
    return Vue.prototype.$httpService
    .put(Url, payload)
  },
  find(id:string|number) {
    let Url = url.replace("{0}", id) 
    return Vue.prototype.$httpService
    .get(Url)
  },
  partial_edit(id:string|number,payload:any){
    const Url = Vue.prototype.$config.api_url +  Vue.prototype.$config.interview.interview_senior_master.replace("{0}", id) 
    return Vue.prototype.$httpService
    .patch(Url,payload)
  },
  delete(id:string|number) {

  },
  list(params = {}) {
  }
}

export default interview;

